var React = require('react');

function IconDrag (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("g",null,React.createElement("polygon",{"fillRule":"evenodd","clipRule":"evenodd","points":"50,24.999 48.607,23.605 48.607,23.606 40.851,15.849 39.457,17.242 \r\n\t\t\t\t47.213,25 39.457,32.757 40.851,34.151 48.606,26.393 48.607,26.394 \t\t\t"}))),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("polygon",{"fillRule":"evenodd","clipRule":"evenodd","points":"10.543,17.242 9.149,15.849 0,24.999 1.394,26.394 1.394,26.394 \r\n\t\t\t\t9.149,34.151 10.543,32.757 2.787,25 \t\t\t"})))]));
}

IconDrag.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"50px","height":"50px","viewBox":"0 0 50 50","enableBackground":"new 0 0 50 50","xmlSpace":"preserve"};

module.exports = IconDrag;

IconDrag.default = IconDrag;
